<template>
  <v-container>
    <component :is="getRiparazioniClientiComponent" />
  </v-container>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  import Index from './../components/riparazioni/clienti/Index'
  import Insert from './../components/riparazioni/clienti/Insert'

  export default {
    name: 'RiparazioniClienti',
    components: {
      Index,
      Insert
    },
    computed: {
      ...mapGetters([
        'getRiparazioniClientiComponent'
      ])
    },
    methods: {
      ...mapMutations([
        'CHANGE_RIPARAZIONI_CLIENTI_COMPONENT'
      ])
    },
    destroyed() {
      this.CHANGE_RIPARAZIONI_CLIENTI_COMPONENT('Index')
    }
  }
</script>

<style>
</style>